import { AuthenticatedRoute } from '../allauth_auth/routing';
import ErrorPage from '../error-page';
import { JoinFlowGuard } from '../lib/join-flow/components/JoinFlowGuard';
import { JoinFlowIndexRedirect } from '../lib/join-flow/components/JoinFlowIndexRedirect';
import { JoinWorkspaceFlow } from '../lib/join-flow/components/JoinWorkspaceFlow';

export const joinRoutes = [
  {
    path: '/join/:orgId',
    element: (
      <AuthenticatedRoute>
        <JoinFlowIndexRedirect />
      </AuthenticatedRoute>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: '/join/:orgId/:stepId',
    element: (
      <AuthenticatedRoute>
        <JoinFlowGuard>
          <JoinWorkspaceFlow />
        </JoinFlowGuard>
      </AuthenticatedRoute>
    ),
    errorElement: <ErrorPage />,
  },
];
